import React from 'react';

import AuthenticatedNavbar from './authenticated';
import { PublicNavbar } from './public';

import { AuthService } from '../../state/auth.service';

export const Navbar = () => {
  let navbar = <PublicNavbar />;

  if (window.location.href.endsWith('/account/signin')) {
    navbar = null;
  } else if (AuthService.isAuthenticated()) {
    navbar = <AuthenticatedNavbar />;
  }

  return navbar;
};



// WEBPACK FOOTER //
// ./src/components/navbar/index.js